// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"b0dbbe62","290":"0f441e7a","468":"6e8ad144","488":"85728879","629":"4c3d0ac4"}[chunkId] + ".chunk.js";
};